import { observer } from 'mobx-react';
import React, { useEffect, useRef, useState } from 'react';
import { NOTE_ALLONGE_ENTITY_TYPE } from '../../../stores/documentForms/docusignStore';
import { Document } from '@roc/feature-types';
import { NoteAllongeContentPage } from './noteAllongeContentPage';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { SignatureFieldHandle, StandardDialog } from '@roc/ui';
import { Grid, Typography } from '@material-ui/core';
import { useStore } from '@roc/client-portal-shared/hooks';
import { DocumentSigningStore } from '../../../stores/documentForms/documentSigningStore';

interface Props {
  onClose: () => void;
  open: boolean;
  document: Document;
  loan: any;
  store: DocumentSigningStore;
}

const NoteAllongeDialog = observer((props: Props) => {
  const { open, onClose, document, loan, store } = props;
  const { globalStore } = useStore();
  const taskId = document?.taskId;
  const signatureRef = useRef<SignatureFieldHandle>(null);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if(open) {
      store.validateNoteAllongeDocument(loan.loanId);
    }
  }, [open]);

  useEffect(() => {
    setErrorMessage(store.noteAllongeErrorMessage);
  }, [store.noteAllongeErrorMessage]);

  const handleSubmit = () => {
    if (signatureRef.current.isSigned()) {
      generateDocument();
      onClose();
    } else {
      globalStore.notificationStore.showErrorNotification({
        message: 'Please sign the document before submitting it',
      });
    }
  };

  const generateDocument = async () => {
    const signatureURL = signatureRef.current.getSignature();
    await store.generateNoteAllongeDocument(signatureURL, loan.loanId);
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          title={'Note Allonge'}
          open={open}
          maxWidth={'lg'}
          handleClose={onClose}
          dialogContent={
            <Grid container >
              <Grid item xs={12}>
                {errorMessage ? (
                  <Typography variant="body1">
                    Document signing is not currently available. {errorMessage}.
                  </Typography>
                ) : (
                  <NoteAllongeContentPage signatureRef={signatureRef} loan={loan} handleSubmit={handleSubmit} />
                )}
              </Grid>
            </Grid>
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          title={'Note Allonge'}
          open={open}
          maxWidth={'lg'}
          handleClose={onClose}
          dialogContent={
            <Grid container >
              <Grid item xs={12}>
                {errorMessage ? (
                  <Typography variant="body1">
                    Document signing is not currently available. {errorMessage}.
                  </Typography>
                ) : (
                  <NoteAllongeContentPage signatureRef={signatureRef} loan={loan} handleSubmit={handleSubmit} />
                )}
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
});

export default NoteAllongeDialog;
